/**
 * El pedido del vídeo de Papá Noel: lo que el padre rellena y lo que el
 * guion puede gastar. Vive en el dominio porque el producto lo valida antes
 * de generar nada; la PoC (`scripts/north-pole-poc/v3-contract.ts`) lo
 * re-exportaba desde aquí en vez de duplicarlo (podada en #486).
 *
 * Los campos comunes, sus topes y sus lectores están en `form-fields.ts`.
 */
import { asFormObject, list, readCommonFields, type BaseOrderForm } from './form-fields'

export { AGE_RANGE, MAX_LENGTH } from './form-fields'

/** El formulario de la carta (`LETTER_STORY`). */
export interface VideoOrderForm extends BaseOrderForm {
  requestedGifts: string[]
  authorizedGifts: string[]
}

/** Dos hechos como mínimo: uno lo gasta la apertura y otro el cierre. */
export const MIN_PERSONAL_DETAILS = 2

/** Cuántas entradas de cada lista gasta el guion (el recorte de `list()`). */
export const MAX_ENTRIES = { interests: 4, requestedGifts: 5, authorizedGifts: 3, personalDetails: 4 } as const

function assertPersonalDetails(form: Record<string, unknown>): string[] {
  const personalDetails = list(form.personalDetails, 'personalDetails', MAX_ENTRIES.personalDetails)
  if (personalDetails.length < MIN_PERSONAL_DETAILS) {
    throw new Error(`El pedido necesita al menos ${MIN_PERSONAL_DETAILS} hechos personales.`)
  }
  return personalDetails
}

/** Las claves van en el orden de siempre: el formulario se persiste y se le manda así al escritor. */
export function assertVideoOrderForm(value: unknown): VideoOrderForm {
  const form = asFormObject(value)
  const common = readCommonFields(form)
  return {
    name: common.name,
    age: common.age,
    location: common.location,
    interests: list(form.interests, 'interests', MAX_ENTRIES.interests),
    requestedGifts: list(form.requestedGifts, 'requestedGifts', MAX_ENTRIES.requestedGifts),
    authorizedGifts: list(form.authorizedGifts, 'authorizedGifts', MAX_ENTRIES.authorizedGifts),
    personalDetails: assertPersonalDetails(form),
    parentMessage: common.parentMessage,
    photoPath: common.photoPath,
    language: common.language,
    tone: common.tone,
  }
}
